import { Component, ComponentNature, Triangle, sceneComponent } from '@hatiolab/things-scene'
import { MCSStatusMixin } from './features/mcs-status-mixin'

const NATURE: ComponentNature = {
  mutable: true,
  resizable: false,
  rotatable: true,
  properties: [
    {
      type: 'number',
      label: 'round',
      name: 'round',
      property: { min: 0, max: 100, step: 1 }
    }
  ]
}

@sceneComponent('Scanner')
export default class Scanner extends MCSStatusMixin(Triangle) {
  static get nature() {
    return NATURE
  }

  is3dish() {
    return true
  }
}

Component.memoize(Scanner.prototype, 'path', false)
